import { prettifyGroqQuery } from "./prettyPrintGroqQuery";

export const uglifyGroqQuery = (query: string) => prettifyGroqQuery(query).replace(/\s+/g, " ");
